// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-tour-popup {
  position: relative;
  bottom: 0;
}
.start-tour-popup .qr-phone {
  width: 300px;
  height: 500px;
  margin: auto;
  padding: 30px;
  padding-top: 60px;
  box-sizing: border-box;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Ffloating-elements%2Fimg-sliderFrameCutOut.png?alt=media&token=fe378f6e-b5ac-4b55-8932-b70c7e28bfd6");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.start-tour-popup .phone-content-top, .start-tour-popup .phone-content-middle, .start-tour-popup .phone-content-bottom {
  width: 90%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: center;
}
.start-tour-popup .phone-content-middle {
  flex-grow: 1;
}
.start-tour-popup .phone-content-bottom {
  display: block;
  flex-grow: 0;
  margin-bottom: 0;
}
.start-tour-popup .qr-code canvas {
  width: 100%;
  border-radius: 20px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/start-tour-popup/start-tour-popup.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;AACJ;AACI;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,8MAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AACR;AAEI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAGI;EACI,YAAA;AADR;AAII;EACI,cAAA;EACA,YAAA;EACA,gBAAA;AAFR;AAKI;EACI,WAAA;EACA,mBAAA;AAHR","sourcesContent":[".start-tour-popup {\n    position: relative;\n    bottom: 0;\n    \n    .qr-phone {\n        width: 300px;\n        height: 500px;\n        margin: auto;\n        padding: 30px;\n        padding-top: 60px;\n        box-sizing: border-box;\n        background-image: url(\"https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Ffloating-elements%2Fimg-sliderFrameCutOut.png?alt=media&token=fe378f6e-b5ac-4b55-8932-b70c7e28bfd6\");\n        background-repeat: no-repeat;\n        background-size: cover;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    .phone-content-top, .phone-content-middle, .phone-content-bottom {\n        width: 90%;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        margin-bottom: 20px;\n        text-align: center;\n    }\n\n    .phone-content-middle {\n        flex-grow: 1;\n    }\n\n    .phone-content-bottom {\n        display: block;\n        flex-grow: 0;\n        margin-bottom: 0;\n    }\n\n    .qr-code canvas{\n        width: 100%;\n        border-radius: 20px;\n    }\n }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
